<template>
  <section>
    <title>Dashboard | Config Options</title>
    <div class="page-loader" v-if="!loaded"><div class="page-pulse"><div></div><div></div><div></div></div></div>
    <div class="state-bar" v-if="loaded">
      <a href="/dashboard">Go To The Server Selection Menu</a>
   </div>
   <form class="form" v-if="loaded">
      <div class="form-field">
        <p class="form-field-title">Prefix</p>
        <p class="form-field-title-description">A message prefix which comes before command in a message.</p>
        <input type="text" name="prefix" @input="update('prefix')" v-model="prefix" class="form-field-text-input" placeholder="." required>
      </div>
      <div class="form-field">
        <p class="form-field-title">Moderator Role</p>
        <p class="form-field-title-description">Users with the selected role will be able to run moderator commands regardless of their discord permissions.</p>
        <v-select :options="arraify(cache.roles).map(r => ({ label: `@${r.name}`, value: r.id }))" @input="update('mod-role')" v-model="mod"></v-select>
      </div>
      <div class="form-field">
        <p class="form-field-title">Administrator Role</p>
        <p class="form-field-title-description">Users with the selected role will be able to run both moderator-only and administrator-only commands regardless of their discord permissions. Use with caution!</p>
        <v-select :options="arraify(cache.roles).map(r => ({ label: `@${r.name}`, value: r.id }))" @input="update('admin-role')" v-model="admin"></v-select>
      </div>
      <div class="form-field">
        <p class="form-field-title">Auto Role</p>
        <p class="form-field-title-description">The role human users receive upon joining.</p>
        <v-select :options="arraify(cache.roles).map(r => ({ label: `@${r.name}`, value: r.id }))" @input="update('auto-role')" v-model="auto"></v-select>
      </div>
      <div class="form-field">
        <p class="form-field-title">Auto Bot Role</p>
        <p class="form-field-title-description">The role bot users receive upon joining.</p>
        <v-select :options="arraify(cache.roles).map(r => ({ label: `@${r.name}`, value: r.id }))" @input="update('auto-bot-role')" v-model="autobot"></v-select>
      </div>
      <div class="form-field">
        <p class="form-field-title">Direct Message Warnings</p>
        <p class="form-field-title-description">Alerts the user upon a given punishment in the direct messages.</p>
        <v-select :options="toggleOptions" @input="update('dm-warn')" v-model="dmOpt"></v-select>
      </div>
      <div class="form-field">
        <p class="form-field-title">Muted Role</p>
        <p class="form-field-title-description">The role bot gives users when they are muted.</p>
        <v-select :options="arraify(cache.roles).map(r => ({ label: `@${r.name}`, value: r.id }))" @input="update('mute-role')" v-model="muteRole"></v-select>
      </div>
      <div class="form-field">
        <p class="form-field-title">Delete Command Messages</p>
        <p class="form-field-title-description">If enabled, bot will delete the message command was triggered with after command is complete.</p>
        <v-select :options="toggleOptions" @input="update('delete')" v-model="deleteOpt"></v-select>
      </div>
    </form>
  </section>
</template>

<script>
export default {
  name: "General",
  watch: {
    confirm (value) {
      this.$emit("setPromptVisibility", value);
    },
    saving (value) {
      this.$emit("setPromptLoading", value);
    }
  },
  data () {
    return {
      loaded: false,
      settings: {},
      cache: {},
      changes: {},
      prefix: null,
      mod: null,
      modRole: null,
      admin: null,
      adminRole: null,
      auto: null,
      autoRole: null,
      autobot: null,
      autobotRole: null,
      confirm: false,
      saving: false,
      dmOpt: null,
      dm: null,
      upgrade: 0,
      toggleOptions: [
        {
          label: "Enabled",
          value: "enabled"
        },
        {
          label: "Disabled",
          value: "disabled"
        }
      ],
      muteRole: null,
      mute: null,
      deleteOpt: null,
      delete: null
    };
  },
  methods: {
    fetchGuildData: async function () {
      const response = await this.$axios.get(`${this.$apiBase}/v1/information/${this.$route.params.id}/cache`, {
        withCredentials: true,
        credentials: "same-origin"
      });
      this.cache = response.data.data;

      const settingsResponse = await this.$axios.get(`${this.$apiBase}/v1/information/${this.$route.params.id}/settings`, {
        withCredentials: true,
        credentials: "same-origin"
      });

      this.settings = settingsResponse.data.data;
      this.loaded = true;

      this.init();
    },
    init: function () {
      this.prefix = this.settings.prefix;
      this.modRole = this.settings.moderator_role;
      this.adminRole = this.settings.administrator_role;
      this.autoRole = this.settings.auto_member_role;
      this.autobotRole = this.settings.auto_bot_role;
      this.mute = this.settings.mute_role;
  
      var defModRole = this.cache.roles[this.settings.moderator_role] ? ({ label: "@" + this.cache.roles[this.settings.moderator_role].name, value: this.cache.roles[this.settings.moderator_role].id }) : ({ label: "None" });
      this.mod = defModRole;
      var defAdminRole = this.cache.roles[this.settings.administrator_role] ? ({ label: "@" + this.cache.roles[this.settings.administrator_role].name, value: this.cache.roles[this.settings.administrator_role].id }) : ({ label: "None" });
      this.admin = defAdminRole;
      var defAutoRole = this.cache.roles[this.settings.auto_member_role] ? ({ label: "@" + this.cache.roles[this.settings.auto_member_role].name, value: this.cache.roles[this.settings.auto_member_role].id }) : ({ label: "None" });
      this.auto = defAutoRole;
      var defAutoBotRole = this.cache.roles[this.settings.auto_bot_role] ? ({ label: "@" + this.cache.roles[this.settings.auto_bot_role].name, value: this.cache.roles[this.settings.auto_bot_role].id }) : ({ label: "None" });
      this.autobot = defAutoBotRole;
      var defMuteRole = this.cache.roles[this.settings.mute_role] ? ({ label: "@" + this.cache.roles[this.settings.mute_role].name, value: this.cache.roles[this.settings.mute_role].id }) : ({ label: "None" });
      this.muteRole = defMuteRole;
      this.dmOpt = this.settings.dm_warnings ? this.toggleOptions[0] : this.toggleOptions[1];
      this.dm = this.settings.dm_warnings ? "enabled" : "disabled";
      this.deleteOpt = this.settings.delete_trigger ? this.toggleOptions[0] : this.toggleOptions[1];
      this.delete = this.settings.delete_trigger ? "enabled" : "disabled";
    },
    arraify: function (object) {
      var output = [];
      for (const key of Object.keys(object)) {
        output.push(object[key]);
      }
      return output;
    },
    save: async function () {
      this.saving = true;

      await this.$axios.post(`${this.$apiBase}/v1/settings/${this.settings.id}/general`, {
        "prefix": this.prefix,
        "mod-role": this.modRole,
        "admin-role": this.adminRole,
        "auto-role": this.autoRole,
        "auto-bot-role": this.autoBotRole,
        "dm_warnings": this.dm,
        "mute-role": this.mute,
        "delete_trigger": this.delete
      }, {
        withCredentials: true,
        credentials: "same-origin"
      });
      await this.fetchGuildData();
      this.changes = {};
      this.saving = false;
      this.updateBar();
    },
    update: async function (field) {
      switch(field) {
        case "prefix":
          if (this.prefix !== this.settings.prefix) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "mod-role":
          this.modRole = this.mod ? this.mod.value : null;
          if (this.modRole !== this.settings.moderator_role) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "admin-role":
          this.adminRole = this.admin ? this.admin.value : null;
          if (this.adminRole !== this.settings.administrator_role) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "auto-role":
          this.autoRole = this.auto ? this.auto.value : null;
          if (this.autoRole !== this.settings.administrator_role) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "auto-bot-role":
          this.autoBotRole = this.autobot ? this.autobot.value : null;
          if (this.autoBotRole !== this.settings.administrator_role) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "dm-warn":
          this.dm = this.dmOpt ? this.dmOpt.value : "disabled";
          if (this.bool(this.dm) !== this.settings.dm_warnings) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "mute-role":
          this.mute = this.muteRole ? this.muteRole.value : null;
          if (this.mute !== this.settings.mute_role) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        case "delete":
          this.delete = this.deleteOpt ? this.deleteOpt.value : "disabled";
          if (this.bool(this.delete) !== this.settings.delete_trigger) this.changes[field] = true;
          else this.changes[field] = false;
          break;
        default:
          console.error(`${field} is not a valid settings field.`);
      }
      this.updateBar();
    },
    updateBar: function () {
      if (this.changes["auto-role"] || this.changes["delete"] || this.changes["mute-role"] || this.changes["auto-bot-role"] || this.changes["admin-role"] || this.changes["dm-warn"] || this.changes["mod-role"] || this.changes["prefix"]) {
        this.confirm = true;
      } else {
        this.confirm = false;
      }
    },
    bool: function (type) {
      if (type === "enabled") {
        return true;
      } else {
        return false;
      }
    },
    discard: function () {
      this.init();
      this.changes = {};
      this.updateBar();
    }
  },
  mounted() {
    this.fetchGuildData();
  }
}
</script>